import LocalStorageKey from 'config/localStorageKey';
import { useAppSelector } from 'store/hooks';

const useSubscriptionSetToFreeLocalStorageKeyName = () => {
  const customerId = useAppSelector(state => state.customer.id);
  if (!customerId) {
    return null;
  }

  return LocalStorageKey.ShouldShowUserIsNowOnFree + customerId;
};

export const useIsSubscriptionSetToFree = () => {
  const subscriptionSetToFreeKey = useSubscriptionSetToFreeLocalStorageKeyName();
  if (!subscriptionSetToFreeKey) {
    return false;
  }

  return localStorage.getItem(subscriptionSetToFreeKey) !== null;
};

export const useRemoveSubscriptionSetToFree = () => {
  const subscriptionSetToFreeKey = useSubscriptionSetToFreeLocalStorageKeyName();

  return () => {
    if (!subscriptionSetToFreeKey) {
      return false;
    }

    localStorage.removeItem(subscriptionSetToFreeKey);
  };
};
